export default [
  {
    title: 'Patterns',
    // icon: 'LayoutIcon',
    icon: 'columns',
    children: [
      {
        title: 'Overview',
        route: 'patterns',
      },
    ],
  },
]
